module.exports = __webpack_public_path__ + "static/media/landing_page_main_image.a0e725fa.svg";